module.exports = __webpack_public_path__ + "static/media/fpo-logo.d97ead63.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/fpo-logo.png
// module id = 1035
// module chunks = 0